import { createEvent, createStore } from 'effector'

export const resetShownFromContinueWatchingRaw = createEvent()
export const $shownFromContinueWatchingRaw = createStore(false).reset(
  resetShownFromContinueWatchingRaw
)
